import { getCartSectionsToRender } from './get-sections'

/**
 * Dissect product form
 *
 * @param formData {Object}
 *
 * @returns {string|null}
 */
const dissectFormMultiple = (formData) => {
  // If variant ID is not present abort mission.
  if (formData.productVariant) {
    const defaultQuantity = 1

    // Collect all the data.
    const variantID = formData.productVariant
    const quantity = formData.quantity ? formData.quantity : defaultQuantity
    const pairing = formData.pairing
    let quantityValue = 1
    if (quantity === 'single') {
      quantityValue = 1
    } else if (quantity === 'pair') {
      quantityValue = 2
    }

    const allConnectedItems = []

    // Created the properties object.
    Object.entries(formData).map(([key, value]) => {
      if (key.includes('connectedProductVariantId') && value.length > 0) {
        const pairingQuantityValue = pairing === 'pair' || quantity === 'pair' ? 2 : 1

        allConnectedItems.push({
          id: value,
          quantity: pairingQuantityValue,
          properties: {
            quantity: pairingQuantityValue === 2 ? 'pair' : 'single',
          },
        })
      }
    })

    // Create the basic data object.
    const data = {
      items: [
        {
          id: variantID,
          quantity: quantityValue,
          properties: {
            quantity: quantityValue === 2 ? 'pair' : 'single',
          },
        },
        ...allConnectedItems,
      ],
      properties: {},
      sections: getCartSectionsToRender().map((section) => section.id),
    }

    // Gets the initial from the variant.
    Object.entries(formData).map(([key, value]) => {
      if (key.includes('initial')) {
        data.items[0].properties.initial = value
      }
    })

    // Gets the engraving from the variant.
    Object.entries(formData).map(([key, value]) => {
      if (key.includes('engraving')) {
        data.items[0].properties.engraving = value
      }
    })

    // Created the properties object.
    Object.entries(formData).map(([key, value]) => {
      if (key.includes('connectedProduct')) {
        // Don't add the connected products to the main product submition.
      } else {
        data.properties[key] = value
      }
    })

    // Return a stringified JSON with the data of the product.
    return JSON.stringify(data)
  }

  // Return null if there is no variant id.
  return null
}

export { dissectFormMultiple }
